export const COLORS = {
  red: "#E50914",
  green: "hsl(151, 100%, 36%)",
  darkgray: "hsl(240, 6%, 28%)",
  lightgray: "hsl(0, 0%, 97%)",
  gray: "#44444c",
  white: "hsl(0, 0%, 100%)",
  black: "hsl(0, 0%, 0%)",
  blue: "hsl(199, 92%, 56%)",
  warning: "hsl(36, 100%, 57%)",
  transparent: "transparent",
};
